<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset pt-4">
        <v-col cols="12">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}"> {{ id ? 'Modifica' : 'Crea' }} Calendario</p>
                    <v-spacer></v-spacer>
                </v-card-title>        
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <fields-generator
                        class="pt-3"
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>

        <v-col class="pt-3" cols="12">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Permessi</p>
                    <v-spacer></v-spacer>
        			<v-row class="pa-0 pr-4">
                        <v-text-field class="hidden-xs-only"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            dense
                            outlined
                        ></v-text-field>
        			</v-row>
                </v-card-title>                
                <v-divider></v-divider>

                <v-container class="pa-0" fluid>
                    <v-progress-linear v-show="loading" height="2" class="my-0" :indeterminate="loading"></v-progress-linear>
                    <v-data-table
                        :items="users"
                        :headers="headers"
                        :disable-pagination="true"
                        hide-default-footer
                        :search="search"
                        class="background-2">
                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

			            <template v-slot:item="props">
                            <tr>
                                <td style="width: 91px">
                                    <v-btn icon small class="mx-0" @click.stop="openEdit(props.item, props.index)">
                                        <v-icon color="teal">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon small class="mx-0" @click.stop="confirmDelete(props.item.id, props.index)">
                                        <v-icon color="pink">delete</v-icon>
                                    </v-btn>
                                </td>
                                <td>{{ printUserName(props.index) }}</td>
                                <td>{{ translatePermission(props.item['permission']) }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-divider></v-divider>
                </v-container>
                <div style="position: relative; height: 20px">
                    <v-fab-transition>
                        <v-btn
                            @click.native="openAdd()"
                            color="primary"
                            small
                            dark
                            absolute
                            left
                            fab
                            style="bottom: -24px; left: 12px">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </div>

                <v-dialog v-model="permissionDialog" max-width="500px" persistent>
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">{{ formTitle }}</p>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pt-4 pb-0">
                            <v-autocomplete
                                label="Utente*"
                                :items="dialogUsersItemsList"
                                v-model="editedItem.user_id"
                                :menu-props="{ maxHeight:'200' }"
                                small-chips
                                deletable-chips
                                v-validate="'required'"
                                :error-messages="errors.collect('Utente')"
                                data-vv-name="Utente"
                                data-vv-as="Utente"
                                :filter="(item, queryText, itemText) => $eventBusUtility.customFilter(item, queryText, itemText, ['subtitle'])"
                                outlined
                                dense>
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        small
                                        pill
                                        @click="data.select">
                                        <v-avatar v-if="data.item.avatar" left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        <v-avatar v-else
                                            left
                                            style="height: 24px !important; width: 24px !important"
                                            class="primary white--text">
                                            {{ getInitialAvatar(data, [])}}
                                        </v-avatar>
                                        <div class="xs3 string-cutter">{{ data.item.text }}</div>
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <v-list-item-avatar v-if="data.item.avatar" style="margin-right: 10px;">
                                        <v-avatar
                                            class="custom-avatar"
                                            :size="34"
                                            :style="{'background-image': 'url(' + data.item.avatar + ')'}">
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-avatar v-else
                                        size="34px"
                                        style="min-width: 34px; width: 34px; height:34px; border-radius: 50%"
                                        class="primary mr-4">
                                        <span style="color: white !important" class="margin-auto">{{ getInitialAvatar(data, [])}}</span>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>

                            <v-select
                                label="Permessi*"
                                :items="permissionsOptions"
                                v-model="editedItem.permission"
                                v-validate="'required'"
                                :error-messages="errors.collect('Permessi')"
                                data-vv-name="Permessi"
                                data-vv-as="Permessi"
                                :menu-props="{'offset-y': true}"
                                outlined
                                dense>
                            </v-select>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="closeDialog">Annulla</v-btn>
                            <v-btn text color="info" @click="savePermission">Salva</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="deleteDialog" max-width="400px">
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">Conferma eliminazione</p>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pt-4">
                            Sei sicuro di voler eliminare questo permesso?
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="deleteDialog = false">Annulla</v-btn>
                            <v-btn text color="error" @click="deleteCalendarUser">Elimina</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-col>

        <v-tooltip top>
			<template v-slot:activator="{ on: tooltip }">
				<v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="updateModel()"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Aggiorna</span>
        </v-tooltip>
		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="updateModel"
			:atExit="exit"
		></confirm-dialog>
    </v-row>
</template>

<script>
	import InputMixin from '@/mixins/InputMixin'

    export default {
        name: 'calendar-edit',
		mixins: [
			InputMixin,
		],
        props: {
            id: Number,
            modelDef: String,
            redirect: Object,
        },
        data() {
            return {
                model: {},
                next: null,
                search: '',
                saved: false,
                fieldsset: {},
                loading: false,
                permissionDialog: false,
                editedIndex: -1,
                editedItem: {
                    calendar_id: null,
                    id: 0,
                    user_id: null,
                    permission: null
                },
                usersOptions: [],
                confirmExit: false,
                deleteDialog: false,
                deleteTarget: null,
                permissionsOptions: [
                    {
                        'text': 'Solo Lettura',
                        'value': 'read',
                    },
                    {
                        'text': 'Lettura/Scrittura Proprietari',
                        'value': 'write_owner',
                    },
                    {
                        'text': 'Lettura/Scrittura Tutto',
                        'value': 'write',
                    },
                ],
            }
        },

        computed: {

            translatePermission() {
                return (text) => {
                    switch  (text) {
                        case'read':
                            return 'Solo Lettura'
                        case 'write_owner':
                            return 'Lettura/Scrittura Proprietari'
                        case 'write':
                            return 'Lettura/Scrittura Tutto'
                        default:
                            return text
                    }
                }
            },
            
            formTitle() {
                return this.editedIndex === -1 ? 'Nuovo Permesso' : 'Modifica Permesso'
            },

            dialogUsersItemsList() {
                let selected = this.users ? this.users
                    .filter((user, index) => index !== this.editedIndex)
                    .map((user) => user.user_id) : []
                return this.usersOptions.map((user_option) => {
                    return selected.includes(user_option.value) ? {...user_option, disabled: true } : user_option
                })
            },

            printUserName(index) {
                return (index) => {
                    if(this.users[index] && this.userById[this.users[index]['user_id']] && this.userById[this.users[index]['user_id']]['text']) {
                        return this.userById[this.users[index]['user_id']]['text']
                    } else ''
                }
            },

            userById() {
                return this.usersOptions.reduce((obj, user) => {
                    obj[user.value] = user
                    return obj 
                }, {})
            },

            modelForWatcher() {
                return _.cloneDeep(this.model);
            },

            users() {
                return this.model.users
            },

            totalItems() {
                return this.users.length
            },

            headers() {
                let headers = [
                    {
                        text: 'Azioni',
                        value: 'action',
                        sortable: false
                    }, 
                    {
                        text: 'Utente',
                        value: 'name',
                        sortable: false
                    }, 
                    {
                        text: 'Permessi',
                        value: 'destination',
                        sortable: false
                    }, 
                ]
                return headers
            }

        },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },

        },

        methods: {

            inizialize() {
                this.axios.get('calendars/' + this.id + '/edit').then(response => {
                    // get body data
                    this.fieldsset = response.data.fields
                    this.usersOptions = response.data.optionsUsers
                    this.model = response.data.model
                    this.$store.commit('endProgress')
                    this.load = true

                }, response => {
                        // error callback
                })
            },

            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },
            
            openAdd() {
                this.editedIndex = -1
                this.editedItem = {
                    calendar_id: this.model.id,
                    id: 0,
                    user_id: null,
                    permission: null
                }
                this.$validator.reset()
                this.permissionDialog = true
            },

            openEdit(item, index) {
                this.editedIndex = index
                this.editedItem = {...item}
                this.$validator.reset()
                this.permissionDialog = true
            },

            closeDialog() {
                this.permissionDialog = false
            },

            savePermission() {
                this.$validator.validateAll().then(result => {
                    if (!result) return

                    this.axios.post('calendaruser', this.editedItem).then(response => {
                        this.$store.commit('setSnackbar', {timeout: 6000, text: 'Salvato', value: true, color: 'success'})

                        if (this.editedIndex === -1) {
                            this.users.unshift({...this.editedItem, id: response.data.id})
                        } else {
                            this.$set(this.users, this.editedIndex, {...this.editedItem, id: response.data.id})
                        }

                        this.closeDialog()
                    }, response => {
                        // error callback
                    })
                }).catch(() => {})
            },

            confirmDelete(id, index) {
                this.deleteTarget = { id, index }
                this.deleteDialog = true
            },

            deleteCalendarUser() {
                let { id, index } = this.deleteTarget
                this.axios.post('calendaruser/delete', {'ids': [id]}).then(response => {
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Eliminato', value: true, color: 'success'})
                    this.users.splice(index, 1)
                    this.deleteDialog = false
                    this.deleteTarget = null
                }, response => {
                    // error callback
                })
            },            

            updateModel() {
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return false
                        }

                        this.saved = true
                        let data = this.model

                        this.axios.put('calendars/' + this.id, data).then(response => {
                            // get body data
                            this.model = {}
                            this.saved = false
                            this.$store.commit('setModelEdited', false)

                            if(this.next != null) {
                                this.next()
                            } else {
                                this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)
                            }
                        }, response => {
                            // error callback
                        })

                    }).catch(() => {

                    })
                }).catch(() => {
                    
                })
            },
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },

        created() {
            this.inizialize()
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
        },
    }
</script>

<style>
    .calendar-color-picker .v-color-picker__swatches {
        height: 250px;
        max-height: 250px !important;
    }
</style>